import React from "react";
import AllActiveBuyer from "../../../ActiveBuyerList/AllActiveBuyer";
import PickColumn from "./PickColumn/PickColumn";

const ViewSettings = () => {

  const Hidden = "hidden";

  return (
    <div className="">
      <div className="overflow-x-auto w-full  ">
        <div className="overflow-hidden rounded-lg border-2 border-gray-200 w-full">
          <div className="border-b">
            <h1 className="px-6 py-4 text-xl font-semibold">View Settings</h1>
          </div>
          <div className="py-5">
            <div className="flex gap-6 justify-center">
             <div className="flex items-center gap-3">
               <h1 className="text-oceanBlue">
                No.of Column Shown in the Table :{" "}</h1>
                <PickColumn/>
             </div>
              
              <div className="flex items-center gap-3">
              <h1 className="text-oceanBlue">
                No.of Rows Shown in the Table :{" "}</h1>
                <select name="" id="">
                  <option value="20">20</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="2500">2500</option>
                  <option value="5000">5000</option>
                </select>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end px-10 pb-5">
            <button type="button" className="text-gray-500 bg-gray-200 hover:text-gray-700 px-3 py-1 rounded-md text-xl">set as Default</button>
          </div>
        </div>
       <div className=" mt-10">
         <AllActiveBuyer Hidden={Hidden} Heading={"All Active Buyers"}/>
       </div>
      </div>
    </div>
  );
};

export default ViewSettings;
